module.exports = __webpack_public_path__ + "static/media/ganamosCrash.8a540cb8.gif";